import { useFlightSearchDataContext } from "@/features/flights/contexts/FlightSearchDataContext";
import { useFlightSortContext } from "@/features/flights/contexts/FlightSortContext";
import { usePreviousFlightSearchData } from "@/hooks/usePreviousSearchData";
import { FlightTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import type { TFlightFormValues } from "@/types/types";
import { getCityName } from "@/utils/locations";

export const useFlightSearchForm = () => {
  const { setPreviousSearchData } = usePreviousFlightSearchData();
  const { resetSortValue } = useFlightSortContext();
  const { updateSearchData } = useFlightSearchDataContext();

  const handleSubmit = (values: TFlightFormValues) => {
    rudderAnalytics.track(FlightTrackingEvents.USER_SEARCHED_FOR_OFFERS, {
      tripType: values.tripType,
      departure_city: getCityName(values.from),
      destination: getCityName(values.to),
      travel_date: values.dates.departure,
      return_date: values.dates.return,
      travellers: values.adult + values.child,
    });
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData(values);
  };

  return { handleSubmit };
};
